import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=0510b01b&scoped=true"
import script from "./suspension.vue?vue&type=script&lang=js"
export * from "./suspension.vue?vue&type=script&lang=js"
import style0 from "./suspension.vue?vue&type=style&index=0&id=0510b01b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510b01b",
  null
  
)

export default component.exports